import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "../data";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchUniversityPageDataIfNeeded } from "../data/universityPageReducer";

const UniversityPage = loadable(() => import("../UniversityPage"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUniversityPageDataIfNeeded(props));
  }, [dispatch]);

  return (
    <ErrorBoundary>
      <UniversityPage {...props} />
    </ErrorBoundary>
  );
};

export { UniversityPage as PreFetchUniversityPage };
export { loadData };
